import { ITestFlow } from '@/shared/types/ITestFlow';
import { IConfigState, ILinkInfo } from './types';

const mutations = {
  setRRP(state: IConfigState, payload: any) {
    state.requiredRegistrationProperties.data = payload;
    state.requiredRegistrationProperties.isLoaded = true;
  },
  setAC(state: IConfigState, payload: any) {
    state.accessConfig.data = payload;
    state.accessConfig.isLoaded = true;
  },
  setOrganizationConfig(state: IConfigState, payload: any) {
    state.organizationConfig.data = payload;
    state.organizationConfig.isLoaded = true;
  },
  setTestFlow(state: IConfigState, payload: ITestFlow) {
    state.testFlow.data = payload;
    state.testFlow.isLoaded = true;
  },
  setManifest(state: IConfigState, payload: any) {
    state.manifest.data = payload;
    state.manifest.isLoaded = true;
  },
  // setup Test Flow data when no Test Flow provided
  setPretestFlow(state: IConfigState) {
    state.testFlow.data = {
      canonicalId: null,
      name: state.organizationConfig?.data?.name || '',
      logoUrl: '',
    };
    state.testFlow.isLoaded = true;
  },
  setLinkInfo(state: IConfigState, payload: ILinkInfo) {
    state.linkInfo.data = payload;
    state.linkInfo.isLoaded = true;
  },
  setLocale(state: IConfigState, payload: any) {
    state.locale.data = payload;
    state.locale.isLoaded = true;
  },
  setDynamicConfig(state: IConfigState, payload: any) {
    state.dynamicConfig.data = payload;
    state.dynamicConfig.isLoaded = true;
  },
  setUrlState(state: IConfigState, urlState: any) {
    state.urlState = urlState;
  },
};

export default mutations;
